







import Vue from 'vue'
import SkipToNav from '~/components/buttons/skipToNav.vue'
export default Vue.extend({
  components: { SkipToNav },
})
